<template lang="pug">
.slide-container
    section.left(v-bind:style="style")
        router-link.more-link(
            v-if="path"
            :to="path"
        )
            img(
                :width="image.width"
                v-lazy="image"
            )
        a.more-link(
            v-else-if="href"
            :href="href"
            :title="slide.title || slide.sub_title"
            :target="target"
        )
            img(
                :width="image.width"
                v-lazy="image"
            )
        img(
            v-else
            :width="image.width"
            v-lazy="image"
        )
    section.right
        .content
            h4(v-if="slide.sub_title") {{ slide.sub_title }}
            h2(v-if="slide.title") {{ slide.title }}
            div(v-if="slide.text" v-line-clamp:24="8")
                p(v-html="slide.text")
            router-link.more-link(
                v-if="path"
                :to="path"
            )
                | {{ linkText }}
            a.more-link(
                v-else-if="href"
                :href="href"
                :title="slide.title || slide.sub_title"
                :target="target"
            )
                | {{ linkText }}
    //- section.left(ref="container")
    //-     component.slide(v-if="image" :is="tag" v-bind="props")
    //-         figure
    //-             img(
    //-                 v-lazy="image"
    //-                 :style="{ width: `${width}px`, height: `${height}px`}"
    //-                 rel="noopener"
    //-             )
    //- section.right
    //-     .content
    //-         h2(v-if="slide.title") {{ slide.title }}
    //-         h4(v-if="slide.sub_title") {{ slide.sub_title }}
    //-         div(v-if="slide.text" v-html="slide.text")
</template>

<script>

import _ from 'lodash'

export default {
    name: 'Slide',
    data() {
        return {
            delay: 0,
            mouseover: false
        }
    },
    props: {
        slide: {
            type: Object,
            required: true,
        },
        maxWidth: {
            type: [Number, String],
            default: true,
        },
        maxHeight: {
            type: [Number, String],
            default: true,
        }
    },
    computed: {
        tag() {
            let tag = 'div'
            if (this.path) tag = 'router-link'
            else if (this.href) tag = 'a'
            return tag 
        },
        props() {
            let props = {};

            switch (this.tag) {
                case 'router-link':
                    props.to = this.path
                    break;
            }

            return props
        },
        image() {

            let image

            if (this.slide && this.slide.images.length) {
                image = this.slide.images[0]
            }

            if (! image) return false

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let fit = _.get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1.1111111111'
            const parameters = {
                // ... _.get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups'),
            }
            let { w, h } = parameters

            let width, height, aspectRatio
            if ( w && h ) {
                aspectRatio = w / h
            }else aspectRatio = 1.777
            
            if (h > 350) {
                height = 350;
                width = height * aspectRatio 
            }else if ( width ) {
                width = w  
            }else width = 400

            height = width / aspectRatio

            if (w && h) {
                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`)
            } else if (! w && ! h) {
                fit += `&w=${width}&h=${height}`
            }

            return {
                height: `${height}px`,
                width: `${width}px`,
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
            }
        },
        width() {
            return (this.maxWidth * 0.5)
        },
        height() {
            if (this.width && this.image.aspectRatio) return this.width / this.image.aspectRatio
            else return undefined
        },
        hyperlink() {
            return _.get(this.slide, 'hyperlink') || {}
        },
        href() {
            let href = false

            if (this.hyperlink.type !== 'internal' && _.get(this.hyperlink, 'href')) {
                const link = this.hyperlink.href
                switch (this.hyperlink.type) {
                    case 'external':
                        if (! _.startsWith(link, 'https://') && ! _.startsWith(link, 'http://')) href = `https://${link}`
                        else href = link
                        break;

                    case 'mailto':
                        href = `mailto:${link}`
                        break;

                    case 'tel':
                        href = `tel:${link}`
                        break;
                }
            }

            return href
        },
        target() {
            return _.get(this.hyperlink, 'target') || '_self'
        },
        path() {
            if (this.hyperlink.type === 'internal' && _.get(this.hyperlink, 'menuItem.path')) return this.hyperlink.menuItem.path
            else return false
        },
        linkText() {
            return _.get(this.hyperlink, 'name') || 'mehr...'
        },
        style() {
            let style = {}

            if (this.slide.color) {
                style.background = this.slide.color
            }

            return style
        },
    },
    methods: {
        hover() {
            this.$emit('focus', this.item)
            this.mouseover = true
        },
        blur() {
            setTimeout(() => {
                this.$emit('blur', this.item)
                this.mouseover = false
            }, this.delay);
        },
    },
    // mounted() {
    //     const calculateMaxWidth = () => {
    //         if (this.$refs.container) {
    //             const style = getComputedStyle(this.$refs.container)
    //             this.maxWidth = this.$refs.container.clientWidth
    //             this.maxWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
    //         }
    //     }

    //     window.addEventListener('resize', _.debounce(calculateMaxWidth, 100))
    //     calculateMaxWidth()
    //     this.$nextTick(() => calculateMaxWidth())
    // }
    // created() {
    //     this.$parent.$on('lazyImageLoad', (slide, image) => {
    //         console.log('lazyImageLoad', slide, image);
    //     })
    //     this.$parent.$on('lazyImageReady', (slide, image) => {
    //         console.log('lazyImageReady', slide, image);
    //     })
    // }
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import '~@/assets/sass/variables';
    .more-link
        color: #000!important
        &:hover
            color: $red!important
            text-decoration: underline
    .slide-container
        display: flex
        background: #eeeeee
        align-items: center
        flex-direction: column
        min-height: 400px
        +tablet
            flex-direction: row
            .left
                text-align: center
                img
                    box-shadow: $box-shadow-2
                    transition: box-shadow .8s ease
                    transition: transform .8s ease
                    &:hover
                        transform: scale(1.04)
                        img
                            box-shadow: $box-shadow-3
        .left, .right
            width: 100%
            padding: 1.5rem
            min-height: 350px
            display: flex
            text-align: center
            justify-content: center
            p
                word-break: break-word

            a
                margin: auto
            h4
                color: #ca080c!important
            +tablet
                align-items: center
                width: 50%
                min-height: 400px
</style>
